export const formatList = (list: Iterable<string>, joinType?: 'and' | 'or') => {
  const formatter = new Intl.ListFormat('en', {
    type: joinType === 'or' ? 'disjunction' : 'conjunction',
  });

  return formatter.format(list);
};
